const DEFAULT_IMPORTS = [
  /^kotlin\.[^.]+$/,
  /^kotlin\.annotation\.[^.]+$/,
  /^kotlin\.collections\.[^.]+$/,
  /^kotlin\.comparisons\.[^.]+$/,
  /^kotlin\.io\.[^.]+$/,
  /^kotlin\.ranges\.[^.]+$/,
  /^kotlin\.sequences\.[^.]+$/,
  /^kotlin\.text\.[^.]+$/,
];

export function isDefaultKtImport(qualifiedName: string): boolean {
  return DEFAULT_IMPORTS.some((i) => i.test(qualifiedName));
}
